<template>
  <div class="max-w-8xl py-7 px-5 sm:px-6 lg:px-8 mx-auto font-thin">
    <slot />
  </div>
</template>
